module.exports = __webpack_public_path__ + "static/media/bathroomSink270.273bb690.png";